import * as React from "react";
import { components } from "react-select";
import CustomTooltip from "components/Custom/CustomTooltip";

export const MultiValueWithCustomTooltip = (props) => {
  const option = props.data;
  const tooltipText = option.tooltip || option.label;

  return (
    <CustomTooltip
      id={`option-tooltip-${option.value}`}
      placement="left"
      value={tooltipText}
    >
      <components.MultiValue {...props} />
    </CustomTooltip>
  );
};

export const customEllipsisMultiSelectStyles = {
  valueContainer: (provided, state) => ({
    ...provided,
    maxWidth: "300px",
  }),
  multiValue: (provided, state) => ({
    ...provided,
    maxWidth: "100%",
  }),
};
